/** The show/hide toggle's accessible name for the current visibility. */
export function passwordToggleLabel(visible: boolean): string {
  return visible ? 'Hide password' : 'Show password';
}
